'use client';

import { useSignOut } from '@shared/auth';
import { Button } from '@shared/components/shadcn';
import { Logout } from '@shared/icons';
import { useClientConfig } from '@shared/utils';
import { useTranslations } from 'next-intl';

function LogoutButton() {
  const t = useTranslations('my_account');
  const config = useClientConfig();
  const signOut = useSignOut();

  const handleLogout = async () => {
    await signOut({ callbackUrl: config.register.redirectUrl });
  };

  return (
    <Button type="button" variant="secondary" className="flex gap-2 w-full md:w-40" data-testid="logout-button" data-track-name="Log Out" onClick={handleLogout}>
      <Logout size="small" />
      {t('logout')}
    </Button>
  );
}

export { LogoutButton };
